export default __webpack_public_path__ + "static/media/tips.08a0e223.png";